import Field from '../../common/Field'
import Affixed, { affixedInputClass } from '../../common/Affixed'
import { useWizard } from '../../../context/WizardContext'
import { BUDGET_UPLIFT } from '../../../utils/budget'
import { FIELDS, peso } from '../../../utils/copy'

/**
 * Step 5 — one number asked, the second derived.
 *
 * The old form asked for both and left the customer to work out why one shopping trip
 * needed two amounts. It needs two because the first is a guess and the second is the
 * rider's authority to spend, and the gap between them is what stops the rider ringing
 * from the counter over fifteen pesos.
 *
 * The derived box is shown rather than hidden, and stays editable. A number computed out
 * of sight and then charged is the kind of surprise this whole redesign exists to remove
 * — and thirty percent is not always the right room.
 *
 * Padala never reaches this screen. There is nothing to buy.
 */
export default function BudgetStep() {
  const { state, errors, setEstimatedTotal, setMaxBudget } = useWizard()

  const estimate = Number(state.estimatedTotal)
  const budget = Number(state.maxBudget)
  const room = Number.isFinite(estimate) && Number.isFinite(budget) && budget > estimate
    ? budget - estimate
    : null

  return (
    <div className="grid gap-4">
      <Field id="estimatedTotal" label={FIELDS.estimatedTotal} error={errors.estimatedTotal} required>
        <Affixed affix="₱" invalid={Boolean(errors.estimatedTotal)}>
          <input
            id="estimatedTotal"
            type="number"
            inputMode="decimal"
            min="0"
            step="1"
            value={state.estimatedTotal}
            onChange={(event) => setEstimatedTotal(event.target.value)}
            aria-invalid={Boolean(errors.estimatedTotal)}
            aria-describedby={errors.estimatedTotal ? 'estimatedTotal-error' : undefined}
            className={`${affixedInputClass(errors.estimatedTotal)} tabular-nums`}
          />
        </Affixed>
      </Field>

      <Field
        id="maxBudget"
        label={FIELDS.maxBudget}
        hint={FIELDS.maxBudgetHint}
        error={errors.maxBudget}
        required
      >
        <Affixed affix="₱" invalid={Boolean(errors.maxBudget)}>
          <input
            id="maxBudget"
            type="number"
            inputMode="decimal"
            min="0"
            step="1"
            value={state.maxBudget}
            onChange={(event) => setMaxBudget(event.target.value)}
            aria-invalid={Boolean(errors.maxBudget)}
            aria-describedby={errors.maxBudget ? 'maxBudget-error' : undefined}
            className={`${affixedInputClass(errors.maxBudget)} tabular-nums`}
          />
        </Affixed>
      </Field>

      {/* Says what the extra is *for*, not what it is. The number is already on screen
          twice; the reason is the part nobody can work out on their own. */}
      {room !== null && (
        <p className="text-body-s text-ink-2 border border-hairline rounded-card bg-surface-2 px-3.5 py-3">
          May sobrang <span className="font-semibold tabular-nums">{peso(room)}</span> ang rider
          kung tumaas ang presyo, kaya hindi ka na niya kailangang tawagan.
          {' '}Dagdag na {Math.round(BUDGET_UPLIFT * 100)}%.
        </p>
      )}
    </div>
  )
}
